import { useMembersContext } from "@pages/members/useMembers"
import membersService from "@services/members.service"
import { useHelperApiFunctions, usePatientData } from "@utils/customHooks"
import { milleniumClientCheck } from "@utils/helpers"
import { get, pick } from "lodash"
import React, { createContext, useContext, useEffect, useState } from "react"

type UseCadenceProps = any
type CadenceContextValues = any

function useCadenceCalendar (props: UseCadenceProps): CadenceContextValues {
    const [calendarCadences, setcalendarCadences] = useState<any>({})

    return {
        calendarCadences,
        setcalendarCadences
    }
}

export function useCadence (props: UseCadenceProps): CadenceContextValues {
    const {patientId, patientName} = usePatientData();
    const [cadences, setcadences] = useState<any[]>([])
    const [cadencesCount, setCadencesCount] = useState<number>(0)
    const [cadenceLoader, setcadenceLoader] = useState<boolean>(false)
    const [isFormOpen, setisFormOpen] = useState<boolean>(false)
    const [formData, setformData] = useState<any>({})
    const [formLoader, setformLoader] = useState<boolean>(false)
    const [showHistory, setshowHistory] = useState<any>(null)
    const [historyLoader, sethistoryLoader] = useState<boolean>(false)
    const [historyData, sethistoryData] = useState<any[]>([])

    const [showCadence, setshowCadence] = useState<boolean>(false)
    const { updateCurrentMemberData, patientFetchLoader, fetchMemberAndNavigateToProfile } = useHelperApiFunctions()

    const {sidebarExpand} = useMembersContext()

    useEffect(
        () => {
            if (!sidebarExpand) {
                setcalendarMonthView('cadences')
            }
        },
        [sidebarExpand]
    )
 
    const listCadence = () => {
        if (patientId) {
            setcadenceLoader(true)
            setcadences([])
            setCadencesCount(0)
            return membersService.listCadence({patient_id: patientId}).subscribe({
            next: (v) => {
                let cadences = get(v , 'data.data.result.result1' ,[])
                setcadences(cadences)
                setCadencesCount(get(v , 'data.data.result.result2.0.totalCount', 0))
                setcadenceLoader(false);

                
                let latestCadence = cadences.filter(
                    (c: any) => c.is_completed === 'N'
                )[0]
                updateCurrentMemberData(patientId, { cadence_id: latestCadence?.cadence_id, cadence_status: latestCadence?.current_cycle_status })
            },
            error: (e) => {
                setcadenceLoader(false);
                console.log(e);
            },
            });
        }
    }

    const createCadence = (start_date: any, end_date: any, frequency: any) => {
        setformLoader(true)
        return membersService.createCadence({patient_id: patientId, start_date, end_date, frequency}).subscribe({
          next: (v) => {
            listCadence()
            closeForm()
            setformLoader(false);
          },
          error: (e) => {
            setformLoader(false);
            console.log(e);
          },
        });

    }

    const updateCadence = (start_date: any, end_date: any, frequency: any) => {
        setformLoader(true)
        return membersService.updateCadence({patient_id: patientId, start_date, end_date, frequency}).subscribe({
          next: (v) => {
            listCadence()
            closeForm()
            setformLoader(false);
          },
          error: (e) => {
            setformLoader(false);
            console.log(e);
          },
        }).closed;

    }

    const touchCadence = () => {
        return membersService.updateCadence({patient_id: patientId}).subscribe({
          next: (v) => {
            console.log(get(v , 'data.data'))
          },
          error: (e) => {
            setcadenceLoader(false);
          },
        });
    }

    const historyCadence = (cadence_id: any) => {
        if (cadence_id) {
            sethistoryLoader(true)
            return membersService.historyCadence({cadence_id}).subscribe({
            next: (v) => {
                sethistoryData(get(v, 'data.data.result'))
                sethistoryLoader(false);
            },
            error: (e) => {
                sethistoryLoader(false);
                console.log(e);
            },
            });
        }
    }

    const showForm = (data: any = {}) => {
        setformData(data)
        setisFormOpen(true)
        toggelHistory(null)
    }

    const closeForm = () => {
        setformData({})
        setisFormOpen(false)
    }

    const toggelHistory = (cadence_id: any) => {
        if (showHistory !== cadence_id && cadence_id) {
            setshowHistory(cadence_id)
            sethistoryData([])
            historyCadence(cadence_id)
        } else {
            setshowHistory(null)
            sethistoryData([])
        }
    }

    const frequencyValues = [
        {
            title: 'Weekly',
            value: 'weekly'
        },
        {
            title: 'Bi-Weekly',
            value: 'biweekly'
        },
        {
            title: 'Monthly',
            value: 'monthly'
        },
        {
            title: 'Quarterly',
            value: 'quarterly'
        }
    ]

    const getStatusDetails = (status: string): any => {
        let statuslist: any = {
            'active': {
                name: 'Active',
                borderColor: '#F2960D',
                backgroundColor: '#FEF5E7',
                color: '#F2960D'
            },
            'active_overdue': {
                name: 'Overdue',
                borderColor: '#E75547',
                backgroundColor: '#FDEEED',
                color: '#E75547'
            },
            'new': {
                name: 'New',
                borderColor: '#0072E3',
                backgroundColor: '#E6F1FC',
                color: '#0072E3'
            },
        }
        return statuslist[status || 'new']
    }

    let cadenceCalendarValues = useCadenceCalendar(props)

    const [calendarMonthView, setcalendarMonthView] = useState<'reminders'|'cadences'>(
        milleniumClientCheck() ? 'cadences' : 'reminders'
    )

    return {
        showCadence,
        setshowCadence,
        patientId,
        patientName,
        cadences,
        cadencesCount,
        cadenceLoader,
        listCadence,
        createCadence,
        updateCadence,
        touchCadence,
        historyCadence,
        historyLoader,
        isFormOpen,
        showForm,
        closeForm,
        formData,
        setformData,
        formLoader,
        setformLoader,
        showHistory,
        setshowHistory,
        frequencyValues,
        toggelHistory,
        historyData,
        getStatusDetails,
        rightDrawerCloseHandler: props.rightDrawerCloseHandler,
        patientFetchLoader,
        fetchMemberAndNavigateToProfile,
        calendarMonthView,
        setcalendarMonthView,
        ...cadenceCalendarValues
    }
}

export const CadenceContext = createContext<CadenceContextValues>(
    {
        cadences: [],
        cadenceCount: 0,
        cadenceLoader: false,
        listCadence: () => {},
        createCadence: () => {},
        updateCadence: () => {},
        touchCadence: () => {},
        formData: {}
    }
)

export const CadenceContextProvider: React.FC<React.PropsWithChildren<UseCadenceProps>> = ({children, ...props}) => {
    const cadenceContextValues = useCadence(props)

    return (
        <CadenceContext.Provider value={cadenceContextValues}>
            {children}
        </CadenceContext.Provider>
    )
}

export const useCadenceContext = () => useContext(CadenceContext)
